import React from 'react';

export default (props) => (
    <span><b>{props.title}: </b> {props.children}<br/></span>
);